//

class WIP {
    constructor() {
        document.querySelectorAll('[data-wip]').forEach((el) => {
            new WIPItem(this, el)
        });

        // Check URL parameters on page load
        this.checkUrlForPopup();
    }

    checkUrlForPopup() {
        const urlParams = new URLSearchParams(window.location.search);
        const popupId = urlParams.get('popup');

        if (popupId) {
            const element = document.querySelector(`[data-wip="${popupId}"]`);
            if (element) {
                // Just call openFromUrl on the existing instance instead of creating a new one
                element._wipItem.openFromUrl();
            }
        }
    }
}

class WIPItem {
    constructor(parent, element) {
        this.parent = parent
        this.element = element
        this.element._wipItem = this // Store reference to this instance
        this.element.addEventListener('click', this.onClick.bind(this))
    }

    onClick(e) {
        console.log('click')
        e.preventDefault()
        let popup = new Popup()
        popup.setContent('WIP (Work-in-Progress)', '')
        popup.open()

        // Update URL with popup identifier
        this.updateUrl(true);

        popup.setLoading(true)
        this.fetch().then((content) => {
            popup.setContent('WIP (Work-in-Progress)', content)
            popup.setLoading(false)

            // Check if group parameter exists to scroll to specific item
            const urlParams = new URLSearchParams(window.location.search);
            const groupId = urlParams.get('group');
            if (groupId) {
                this.scrollToGroup(groupId);
            }
        })

        // Listen for popup close to update URL
        popup.onClose = () => this.updateUrl(false);
    }

    openFromUrl() {
        let popup = new Popup()
        popup.setContent('WIP (Work-in-Progress)', '')
        popup.open()

        popup.setLoading(true)
        this.fetch().then((content) => {
            popup.setContent('WIP (Work-in-Progress)', content)
            popup.setLoading(false)

            // Check if group parameter exists to scroll to specific item
            const urlParams = new URLSearchParams(window.location.search);
            const groupId = urlParams.get('group');
            if (groupId) {
                this.scrollToGroup(groupId);
            }
        })

        // Listen for popup close to update URL
        popup.onClose = () => this.updateUrl(false);
    }

    scrollToGroup(groupId) {
        setTimeout(() => {
            const groupElement = document.querySelector(`.popup__body [data-group="${groupId}"]`);
            if (groupElement) {
                groupElement.scrollIntoView({ behavior: 'smooth' });
                groupElement.classList.add('highlight-group');
                setTimeout(() => {
                    groupElement.classList.remove('highlight-group');
                }, 2000);
            }
        }, 300);
    }

    updateUrl(isOpen) {
        const url = new URL(window.location);

        if (isOpen) {
            url.searchParams.set('popup', this.element.dataset.wip);
            // Keep the group parameter if it exists
            const group = url.searchParams.get('group');
            if (group) {
                url.searchParams.set('group', group);
            }
        } else {
            url.searchParams.delete('popup');
            url.searchParams.delete('group');
        }

        // Update URL without reloading page
        window.history.pushState({}, '', url);
    }

    fetch() {
        return fetch(this.element.dataset.wip).then((response) => {
            return response.text()
        })
    }
}

class Popup {
    constructor() {
        this.el = document.createElement('div')
        this.el.classList.add('popup')
        this.el.innerHTML = `
            <div class="popup__content">
                <div class="popup__header">
                    <h2 class="popup__title">Title</h2>
                    <button class="popup__close"><img src="/img/icons/close.svg?v=1658843002" style="width: 15px; cursor: pointer;"></button>
                </div>
                <div class="popup__body-wrapper">
                    <div class="popup__body">
                    </div>
                </div>
            </div>
        `
        this.el.querySelector('.popup__close').addEventListener('click', this.close.bind(this))

        // Callback function for close event
        this.onClose = null;

        this.el.addEventListener('submit', (e) => {
            if (!(e.target && e.target.matches('form'))) {
                return
            }

            e.preventDefault()
            const formData = new FormData(e.target);
            const searchParams = new URLSearchParams();

            for (const pair of formData) {
                searchParams.append(pair[0], pair[1]);
            }

            this.setLoading(true)

            fetch(e.target.getAttribute('action'), {
                method: e.target.getAttribute('method'),
                body: searchParams,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
                .then(response => response.text())
                .then(data => {
                    this.setBody(data)
                    this.setLoading(false)
                })
                .catch(error => {
                    console.error('Error:', error)
                    this.setLoading(false)
                });
        })

        this.el.addEventListener('click', (e) => {
            // Add handler for share action
            if (e.target.closest('[data-group-share-action]')) {
                e.preventDefault();
                const groupContainer = e.target.closest('[data-group]');
                if (groupContainer) {
                    const groupValue = groupContainer.getAttribute('data-group');
                    this.handleShareAction(groupValue);
                }
                return;
            }

            if (!e.target.closest('[data-link]')) {
                return
            }
            e.preventDefault()

            const isOK = confirm('Tem a certeza?')
            if (!isOK) {
                return
            }

            this.setLoading(true)
            fetch(e.target.closest('[data-link]').getAttribute('href'))
                .then(response => response.text())
                .then(data => {
                    this.setBody(data)
                    this.setLoading(false)
                })
                .catch(error => {
                    console.error('Error:', error)
                    this.setLoading(false)
                });

        }, false);

        // Add CSS for highlighting shared group
        this.addHighlightStyles();
    }

    open() {
        document.body.appendChild(this.el)
    }

    close() {
        this.el.remove()
        // Call onClose callback if defined
        if (typeof this.onClose === 'function') {
            this.onClose();
        }
    }

    setContent(title, body) {
        this.el.querySelector('.popup__title').innerText = title
        this.el.querySelector('.popup__body').innerHTML = body
    }

    setBody(content) {
        this.el.querySelector('.popup__body').innerHTML = content
    }

    setLoading(status) {
        if (status) {
            this.el.classList.add('--loading')
        } else {
            this.el.classList.remove('--loading')
        }
    }

    // Method to handle share button click
    handleShareAction(groupValue) {
        // Create shareable URL with popup and group parameters
        const url = new URL(window.location);

        // Get popup ID from the current URL
        const popupId = url.searchParams.get('popup');

        if (popupId) {
            url.searchParams.set('popup', popupId);
            url.searchParams.set('group', groupValue);

            // Copy URL to clipboard
            navigator.clipboard.writeText(url.toString())
                .then(() => {
                    alert('Link copiado para a área de transferência!');
                })
                .catch(err => {
                    console.error('Erro ao copiar link: ', err);
                    // Fallback method
                    this.showCopyLinkDialog(url.toString());
                });
        }
    }

    // Fallback method for browsers that don't support clipboard API
    showCopyLinkDialog(link) {
        const input = document.createElement('input');
        input.value = link;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        alert('Link copiado para a área de transferência!');
    }

    // Add CSS for highlighting the shared group
    addHighlightStyles() {
        if (!document.getElementById('highlight-group-styles')) {
            const style = document.createElement('style');
            style.id = 'highlight-group-styles';
            style.textContent = `
                .highlight-group {
                    animation: highlightFade 2s;
                }

                @keyframes highlightFade {
                    0% { background-color: rgba(255, 255, 0, 0.5); }
                    100% { background-color: transparent; }
                }
            `;
            document.head.appendChild(style);
        }
    }
}

export default WIP